export const API_HOST = process.env.API_HOST;

import {
	initRequest,
	requestFailure,
	requestFetching,
	requestSuccess,
	setRequest,
	setRequestMeta,
	hasRequest
} from "@stofloos/actions/requests";
import { checkFetchStatus } from "@stofloos/actions/auth";
import { setObject } from "@stofloos/actions/crud";

export const SET_FILE = "SET_FILE";
export const SET_FILES = "SET_FILES";

export const uploadImage = (requestId, images, base_path, isPrivate) => {
	return (dispatch, getState) => {
		const state = getState();

		if (state.StofwareAuth.access_token) {
			dispatch(initRequest(requestId, "image"));
			dispatch(setRequest(requestId, true, false, false));

			let formData = new FormData();

			for (let x = 0; x < images.length; x++) {
				formData.append("images", images[x]);
			}

			let url = new URL(`${API_HOST}/images`);

			fetch(url, {
				headers: {
					Authorization: "Bearer " + state.StofwareAuth.access_token,
					Private: isPrivate,
					"Base-Path": base_path
				},
				body: formData,
				method: "POST"
			})
				.then(function(response) {
					return response.json();
				})
				.then(
					function(data) {
						if (data.status === "success") {
							let results = data.result;

							dispatch(setFiles(requestId, results));
							dispatch(setRequest(requestId, false, false, true));
						}
						if (data.status === "error") {
							console.error("Error response");
						}
					}.bind(this)
				)
				.catch(
					function(ex) {
						console.error(ex);
					}.bind(this)
				);
		}
	};
};

export function readPrivateImage(requestId, params) {
	return (dispatch, getState) => {
		const state = getState();

		const request = state.requests[requestId];

		if (!hasRequest(requestId, request)) {
			return;
		}

		dispatch(requestFetching(requestId));

		if (state.StofwareAuth.access_token) {
			let url = new URL(`${API_HOST}/images`);

			url.search = new URLSearchParams(params);
			fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + state.StofwareAuth.access_token
				}
			})
				.then(checkFetchStatus(dispatch, getState))
				.then(res => res.json())
				.then(json => {
					dispatch(setFiles(requestId, json.images));
					dispatch(setRequestMeta(requestId, null, null, data.id));
					dispatch(requestSuccess(requestId));
				})
				.catch(error => dispatch(requestFailure(error, requestId)));
		}
	};
}

export function exportXLS(requestId, params) {
	return (dispatch, getState) => {
		const state = getState();
		const request = state.requests[requestId];

		if (!hasRequest(requestId, request)) {
			return;
		}

		dispatch(requestFetching(requestId));

		if (state.StofwareAuth.access_token) {
			let url = new URL(`${API_HOST}/` + request.endpoint);
			if (request.queryFilters) {
				params["filters"] = JSON.stringify(request.queryFilters);
			}

			url.search = new URLSearchParams(params);
			fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + state.StofwareAuth.access_token
				}
			})
				.then(checkFetchStatus(dispatch, getState))
				.then(res => res.blob())
				.then(blob => {
					var objectURL = URL.createObjectURL(blob);
					window.open(objectURL);
					dispatch(setRequestMeta(requestId, null, null, data.id));
					dispatch(requestSuccess(requestId));
				})
				.catch(error => dispatch(requestFailure(error, requestId)));
		}
	};
}

// export const uploadFile = (file) => {
//     return (dispatch, getState) => {
//         const state = getState();
//
//         if (state.StofwareAuth.access_token) {
//
//             //File name is unique requestid
//             dispatch(initRequest(file.fileName,"file"));
//
//
//             let formData = new FormData();
//             formData.append('file', image, image.name);
//             let url = new URL(`${API_HOST}/images`);
//
//             fetch(url, {
//                 headers: {
//                     'Authorization': "Bearer " + state.StofwareAuth.access_token,
//                     'Private': false,
//                     'Base-Path': "product"
//                 },
//                 body: formData,
//                 method: 'POST'
//             }).then(function (response) {
//                 return response.json()
//             }).then(function (data) {
//                 if (data.status === 'success') {
//                     let imgUrl = data.result;
//
//                     dispatch(setFile(image.name, image.type, imgUrl));
//                     dispatch(setRequest(image.name, false, false, true ))
//                 }
//                 if (data.status === 'error') {
//                     console.error("Error response")
//                 }
//             }.bind(this)).catch(function (ex) {
//                 console.error(ex);
//             }.bind(this));
//
//         }
//     }
// };
const setFiles = (requestId, result) => {
	return {
		type: SET_FILES,
		requestId,
		result
	};
};

const setFile = (fileName, fileType, result) => {
	return {
		type: SET_FILE,
		fileName,
		fileType,
		result
	};
};
